import { ref, watch } from "vue";
type DraggableType = "finding" | "image";
type DraggableItem = { id: number } & Record<string, any>;
type DraggableObject = {
  type: DraggableType;
  item: DraggableItem;
};
const draggedItem = ref<DraggableObject | null>(null);

export const useDragItem = (type: DraggableType) => {
  function onDragStart(item: DraggableItem, e: DragEvent) {
    draggedItem.value = { item, type };

    e.dataTransfer?.setData("text/plain", String(item.id));
    e.target?.addEventListener(
      "dragend",
      () => {
        draggedItem.value = null;
      },
      { once: true }
    );
  }

  return { onDragStart, draggedItem };
};

export const useDropZone = (
  onDropCallback: ({ item, type }: DraggableObject) => void
) => {
  const dragover = ref(false);

  const onDrop = () => {
    if (draggedItem.value) {
      onDropCallback(draggedItem.value);
    }
    dragover.value = false;
  };

  watch(draggedItem, (newVal) => {
    if (!newVal) {
      dragover.value = false;
    }
  });

  const onDragover = (e: DragEvent) => {
    e.preventDefault();
    dragover.value = true;
  };

  const onDragleave = () => {
    dragover.value = false;
  };

  return {
    dragover,
    onDrop,
    onDragover,
    onDragleave,
  };
};
